import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { MappingFilter } from "../../../../../api/models/mapping-filter";
import { SecurityMappingService } from "../../../../../api/services/security-mapping.service";
import { ConfirmationService, MessageService } from "primeng/api";
import RemoveAsReportedSecurityParams = SecurityMappingService.RemoveAsReportedSecurityParams;
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
  trimStringFields,
} from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-security-unreferenced",
  // imports: [],
  templateUrl: "./unreferenced.component.html",
  styleUrl: "./unreferenced.component.css",
  standalone: false,
})
export class SecurityUnreferencedComponent implements OnChanges {
  @Input() isActive: boolean = false;
  private hasLoadedOnce = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]?.currentValue === true) {
      this.hasLoadedOnce = false;
    }
  }
  ref!: DynamicDialogRef;
  selectedDialogRow: any = null;
  searchByName?: string;
  searchBySecurityType?: string;
  // Pagination for Issuers
  issuerFirst = 0;
  issuerRows = 10;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // Pagination for Security
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  unReferenceSecurity: any[] = [];
  selectedUnReferenceSecurity: any[] = [];
  constructor(
    public dialogService: DialogService,
    public _securityMappingService: SecurityMappingService,
    public _messageService: MessageService,
    public confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {}

  onDeleteClick(product: any) {
    this.confirmationService.confirm({
      message: "Are you sure you want to un-reference this security?",
      header: "Confirm Un-Reference",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const params: RemoveAsReportedSecurityParams = {
          asReportedSecurityId: product.asReportedSecurityId,
          reason: "Deleted as reported successfully",
        };
        this.isLoading = true;
        this._securityMappingService
          .removeAsReportedSecurity(params)
          .subscribe({
            next: (value) => {
              // handle success if needed
              this.getUnReferenceSecurities();
            },
            error: (err) => {
              this.isLoading = false;
              this._messageService.add({
                summary: err.error?.message || "Error occurred",
                severity: "error",
              });
            },
            complete: () => {
              this.isLoading = false;
            },
          });
      },
    });
  }

  onIssuerPageChange(event: any) {
    this.issuerFirst = event.first;
    this.issuerRows = event.rows;
  }

  onSearch() {
    // Trim string search fields before building params
    this.searchByName = this.searchByName?.trim() || undefined;
    this.searchBySecurityType = this.searchBySecurityType?.trim() || undefined;

    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnReferenceSecurities();
  }

  getUnReferenceSecurities() {
    const params: MappingFilter = {
      searchByName: this.searchByName,
      searchBySecurityType: this.searchBySecurityType,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      status: "UNREFERENCED",
    };
    this.isLoading = true;
    this._securityMappingService.getSecurityMapping(params).subscribe({
      next: (value) => {
        this.unReferenceSecurity = value.UnReferencedSecurity ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unReferenceSecurity?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }

  loadData(event: any) {
    if (!this.isActive) return;
    if (!this.hasLoadedOnce && event.first === 0) {
      this.hasLoadedOnce = true;
    } else if (!this.hasLoadedOnce) {
      return;
    }

    if (event.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }

    this.paginator.pageSize = event.rows;
    this.getUnReferenceSecurities();
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(
    event: ClipboardEvent,
    field: "searchByName" | "searchBySecurityType"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
